
































































































































































import Vue from 'vue';
import { FormFieldValidation, RouteHelpers, ObjectHelper } from '@/mixins';
import { Dictionary, Configuration, ValueType, ScriveTemplateSigningPartyFieldPlacementModel } from '@/types';
import { ValidationModel } from '@/types/models/validation';
import { SignaturePageNumberLocationType } from '@/types/enums/SignaturePageNumberLocationType';
import MStoreFormSelect from '@/components/shared/MStoreFormSelect.vue';
import { EnumUtils } from '@/utils';
import MStoreFormGroup from '@/components/shared/MStoreFormGroup.vue';

export default Vue.extend({
  name: 'ScriveUpdateSigningPartyFieldPlacement',
  mixins: [FormFieldValidation, RouteHelpers, ObjectHelper],
  props: {
    isParentLoading: {
      type: Boolean,
      default: false
    },
    isParentSubmitting: {
      type: Boolean,
      required: true
    },
    fieldPlacement: {
      type: Object as () => ScriveTemplateSigningPartyFieldPlacementModel,
      required: true
    },
    serverValidationMessage: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      hasError: false,
      errorMessage: ''
    };
  },
  computed: {
    pageNumberLocationType: {
      get(this: any) {
        return this.fieldPlacement.pageNumberLocationType;
      },
      set(value: number) {
        this.$emit('update:page-number-location-type', value);
      }
    },
    pageNumber: {
      get(this: any) {
        return this.fieldPlacement.pageNumber.toString();
      },
      set(value: number) {
        this.$emit('update:page-number', value && Number(value));
      }
    },
    signaturePlacementType: {
      get(this: any) {
        return this.fieldPlacement.signaturePlacementType?.toString() || 1;
      },
      set(value: number) {
        this.$emit('update:signature-placement-type', value);
      }
    },
    relativeXPosition: {
      get(this: any) {
        return this.fieldPlacement.relativeXPosition.toString();
      },
      set(value: number) {
        this.$emit('update:relative-x-position', value && Number(value));
      }
    },
    relativeYPosition: {
      get(this: any) {
        return this.fieldPlacement.relativeYPosition.toString();
      },
      set(value: number) {
        this.$emit('update:relative-y-position', value && Number(value));
      }
    },
    relativeWidth: {
      get(this: any) {
        return this.fieldPlacement.relativeWidth.toString();
      },
      set(value: number) {
        this.$emit('update:relative-width', value && Number(value));
      }
    },
    relativeHeight: {
      get(this: any) {
        return this.fieldPlacement.relativeHeight.toString();
      },
      set(value: number) {
        this.$emit('update:relative-height', value && Number(value));
      }
    },
    relativeFontSize: {
      get(this: any) {
        return this.fieldPlacement.relativeFontSize.toString();
      },
      set(value: number) {
        this.$emit('update:relative-font-size', value && Number(value));
      }
    }
  },
  methods: {
    async onSubmit(this: any) {
      this.resetFormValidation();
      try {
        const isValid = await this.$validator.validate();
        this.$emit('save');
      } catch (error) {
        this.$log('Error updating field placement', error);
      } finally {
        this.submitIsLoading = false;
      }
    },
    onCancel() {
      this.navigateToEditSigningPartyField();
    },
    navigateToEditSigningPartyField(this: any) {
      const param = {} as Dictionary<any>;
      param.documentTypeId = this.$route.params.documentTypeId;
      param.templateId = this.$route.params.templateId;
      param.signingPartyId = this.$route.params.signingPartyId;
      param.id = this.$route.params.signingPartyFieldId;

      this.$router.push({
        name: Configuration.Scrive.SigningPartyField.Edit.name,
        params: param
      });
    }
  },
  watch: {
    serverValidationMessage(this: any, value: string) {
      if (!this.isNullOrEmpty(value)) {
        this.addFormValidationError(value);
      }
    }
  },
  created(this: any) {
    this.pageNumberValidation = {
      required: true,
      valueType: ValueType.Integer,
      minValue: 1,
      maxValue: 100
    } as ValidationModel;
    this.coordValidation = {
      required: true,
      valueType: ValueType.Decimal,
      minValue: 0,
      maxValue: 1
    } as ValidationModel;
    this.pageNumberLocationTypeValidation = {
      required: true
    } as ValidationModel;
    this.pageNumberLocationTypes = EnumUtils.getEnumValues(SignaturePageNumberLocationType);
    this.signaturePlacementTypes = [
      {
        value: 0,
        text: 'Signature'
      },
      {
        value: 1,
        text: 'Date'
      }
    ];
  },
  components: {
    MStoreFormSelect,
    MStoreFormGroup
  }
});
